import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'were_recs_of_all_workrelated_injuries_fatalities_accidents_and'

export const dataPointDefinition = {
  retracedId: 'were_recs_of_all_workrelated_injuries_fatalities_accidents_and',
  name: 'Were records of all work-related injuries, fatalities, accidents and incidents retained for at least 12 months?',
  description: '',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'records',
    },
    {
      name: 'Yes- but records are incomplete',
      key: 'YES_BUT_RECS_ARE_INCOMPLETE',
      slcpIndex: 2,
      slcpOptionName: 'records',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 3,
      slcpOptionName: 'records',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'YES_BUT_RECS_ARE_INCOMPLETE', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-53',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17030,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
